import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Cart controller connected")
  }

  async submitForm(event) {
    event.preventDefault()

    const form = event.target
    const formData = new FormData(form)

    // Express checkout: skip AJAX, let server redirect straight to checkout
    const expressField = form.querySelector('#partner_express_checkout')
    if (expressField && expressField.value === 'true') {
      form.removeAttribute('data-action')
      form.submit()
      return
    }

    // Show loading state
    const submitButton = form.querySelector('button[type="submit"]')
    const originalText = submitButton ? submitButton.innerHTML : ''
    if (submitButton) {
      submitButton.innerHTML = '<svg class="animate-spin h-6 w-6 mx-auto" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>'
      submitButton.disabled = true
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })

      const data = await response.json()

      console.log('Cart Controller: Response received', data)
      console.log('Cart Controller: Item count:', data.item_count)
      console.log('Cart Controller: Total:', data.total)

      if (response.ok && data.success) {
        this.updateCartCounter(data.item_count)

        // Track add to cart before leaving the page: gtag/fbq calls are
        // fire-and-forget, and a navigation right after them still sends.
        this.trackAddToCart(data)

        // Straight to the cart. Until 2026-10-12 this opened a
        // "Zum Warenkorb hinzugefügt" modal with "Zum Warenkorb" / "Weiter
        // einkaufen"; one in three carts was never paid and every extra step
        // before the pay button costs a share of them. Nobody adds a second
        // gift card from the modal; the cart page has its own "add another".
        // The button keeps its spinner until the cart page replaces it.
        this.redirecting = true
        window.location.assign(`/carts/${data.cart_uuid}`)
        return
      } else {
        // Show error message
        alert(data.error || 'Fehler beim Hinzufügen zum Warenkorb')
      }
    } catch (error) {
      console.error('Error adding to cart:', error)
      alert('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.')
    } finally {
      // Restore button state, unless the cart page is about to replace it
      if (submitButton && !this.redirecting) {
        submitButton.innerHTML = originalText
        submitButton.disabled = false
      }
    }
  }

  updateCartCounter(count) {
    // Update cart counter in header if exists
    const cartCounters = document.querySelectorAll('[data-cart-count]')
    cartCounters.forEach(counter => {
      counter.textContent = count
      counter.classList.remove('hidden')
    })
  }

  trackAddToCart(data) {
    // Track with Meta Pixel if available
    if (typeof fbq !== 'undefined') {
      try {
        fbq('track', 'AddToCart', {
          content_ids: [data.product_id],
          content_type: 'product',
          value: data.amount,
          currency: 'EUR'
        })
      } catch (e) {
        console.error('Meta Pixel tracking failed:', e)
      }
    }

    // Track with Google Analytics if available
    if (typeof gtag !== 'undefined') {
      try {
        gtag('event', 'add_to_cart', {
          currency: 'EUR',
          value: data.amount,
          items: [{
            item_id: data.product_id,
            item_name: data.product_name,
            price: data.amount,
            quantity: 1
          }]
        })
      } catch (e) {
        console.error('GA tracking failed:', e)
      }
    }
  }
}
